import React from "react";
import Navbar from "../headers_footer/navbar";
import Flexproducts from "../components/flexproducts";
import Header from "../headers_footer/header";

const Shampoo = () => {

return (

<div>

<Navbar />
<Flexproducts type="shampoo" />
<Header></Header>

</div>

);
};

export default Shampoo;